module.exports = __webpack_public_path__ + "static/project-12d-e4848a81df088a13cb81d3430077859f.png";